import { AxiosRequestConfig } from "axios";
import BaseError from "es6-error";

class NetworkError extends BaseError {
    config: AxiosRequestConfig;
    constructor(error: any) {
        super("The API is not responding");

        const { config } = error;

        this.config = config;
    }
}

export default NetworkError;
